"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WAITING = exports.NOT_STARTED = exports.IN_PROGRESS = exports.DEFERRED = exports.COMPLETED = void 0;
var COMPLETED = 'COMPLETED';
exports.COMPLETED = COMPLETED;
var DEFERRED = 'DEFERRED';
exports.DEFERRED = DEFERRED;
var IN_PROGRESS = 'IN_PROGRESS';
exports.IN_PROGRESS = IN_PROGRESS;
var NOT_STARTED = 'NOT_STARTED';
exports.NOT_STARTED = NOT_STARTED;
var WAITING = 'WAITING';
exports.WAITING = WAITING;